"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavailableForLegalReasons = void 0;
const ApiException_1 = require("./ApiException");
class UnavailableForLegalReasons extends ApiException_1.ApiException {
    constructor(message = 'Unavailable For Legal Reasons.', data) {
        super(message, data);
    }
}
exports.UnavailableForLegalReasons = UnavailableForLegalReasons;
